import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "op-table-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "opPaginationContainer top"
}
const _hoisted_3 = { class: "opPaginationNumberContainer" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "opItemsTotal" }
const _hoisted_6 = { class: "opItemsTotalText" }
const _hoisted_7 = { class: "op-row op-header" }
const _hoisted_8 = {
  key: 1,
  class: "op-empty-row"
}
const _hoisted_9 = {
  key: 1,
  class: "opPaginationContainer bottom"
}
const _hoisted_10 = { class: "opPaginationNumberContainer" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "opItemsTotal" }
const _hoisted_13 = { class: "opItemsTotalText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTopPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
            }, "<"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (p) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["opPaginationNumber", { selected: _ctx.selectedPage === p }]),
                key: p,
                onClick: ($event: any) => (_ctx.goToPage(p))
              }, _toDisplayString(p), 11, _hoisted_4))
            }), 128)),
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
            }, ">"),
            _withDirectives(_createElementVNode("select", {
              class: "opItemsPerPage",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.xItemsPerPage) = $event))
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("option", { value: 10 }, "10", -1),
              _createElementVNode("option", { value: 25 }, "25", -1),
              _createElementVNode("option", { value: 50 }, "50", -1),
              _createElementVNode("option", { value: 100 }, "100", -1)
            ]), 512), [
              [_vModelSelect, _ctx.xItemsPerPage]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createTextVNode("Totale: ")),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.serverSide ? _ctx.total : _ctx.processedItems.length), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "op-table-scroll",
      ref: "scrollEl",
      style: _normalizeStyle(_ctx.scrollStyle)
    }, [
      _createElementVNode("div", {
        class: "op-table",
        ref: "tableEl",
        style: _normalizeStyle(_ctx.tableStyle)
      }, [
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        (_ctx.pagedItems.length > 0)
          ? _renderSlot(_ctx.$slots, "default", {
              key: 0,
              items: _ctx.pagedItems
            })
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "empty", {}, () => [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "op-empty-default" }, "Nessun elemento da mostrare", -1))
              ])
            ]))
      ], 4)
    ], 4),
    (_ctx.showBottomPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[12] || (_cache[12] = _createElementVNode("div", null, null, -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
            }, "<"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (p) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["opPaginationNumber", { selected: _ctx.selectedPage === p }]),
                key: p,
                onClick: ($event: any) => (_ctx.goToPage(p))
              }, _toDisplayString(p), 11, _hoisted_11))
            }), 128)),
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
            }, ">"),
            _withDirectives(_createElementVNode("select", {
              class: "opItemsPerPage",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.xItemsPerPage) = $event))
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("option", { value: 10 }, "10", -1),
              _createElementVNode("option", { value: 25 }, "25", -1),
              _createElementVNode("option", { value: 50 }, "50", -1),
              _createElementVNode("option", { value: 100 }, "100", -1)
            ]), 512), [
              [_vModelSelect, _ctx.xItemsPerPage]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[11] || (_cache[11] = _createTextVNode("Totale: ")),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.serverSide ? _ctx.total : _ctx.processedItems.length), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}